import { httpClient } from "./httpClient";

type Employee = {
  id: number;
  email: string;
  location: string;
  userNtLogin: string;
  managerEmail: string;
  vpemail: string;
  svpemail: string;
  secondManagerEmail: string;
  active: boolean;
  divestitureCode: string;
  networkId: string;
};

type Data = {
  employees: Employee[];
};

type DataPaginated = {
  employees: Employee[];
  totalCount: number;
};

type EmployeeWithDelegate = {
  employeeId: number;
  name: string;
  userEmail: string;
};

type EmployeesWithDelegatesPaginated = {
  employeesWithDelegates: EmployeeWithDelegate[];
  totalCount: number;
};

export async function getEmployees(): Promise<Employee[]> {
  try {
    const { data } = await httpClient.get<Data>(`/api/v1/employees`);

    return data.employees;
  } catch (error) {
    throw error;
  }
}

export async function getEmployeeById(id: number): Promise<Employee> {
  try {
    const { data } = await httpClient.get<Employee>(`/api/v1/employees/${id}`);

    return data;
  } catch (error) {
    throw error;
  }
}

export async function getPaginatedEmployees(
  page: number,
  perPage: number,
  where: string
): Promise<DataPaginated> {
  try {
    // 0 = page 1, 1 = page 2 etc.
    const { data } = await httpClient.get<DataPaginated>(
      `/api/v1/employeespaginated/${page}/${perPage}/searchemail?email=${where}`
    );

    return data;
  } catch (error) {
    throw error;
  }
}

export async function getEmployeeByEmail(email?: string): Promise<Employee> {
  try {
    const { data } = await httpClient.get<Employee>(
      `/api/v1/employees${email ? `/searchemail?email=${email}` : ``}`
    );

    return data;
  } catch (error) {
    throw error;
  }
}

export async function getPaginatedEmployeesWithDelegates(
  page: number,
  perPage: number,
  where: string
): Promise<EmployeesWithDelegatesPaginated> {
  try {
    const { data } = await httpClient.get<EmployeesWithDelegatesPaginated>(
      `/api/v1/employeeswithdelegatespaginated/${page}/${perPage}/searchemailorname?search=${where}`
    );

    return data;
  } catch (error) {
    throw error;
  }
}
